import React from 'react';
import PropTypes from 'prop-types';
import { Form, Checkbox } from 'antd';
import { SelectTourNews } from './selectTourNews';

export const SelectTourNewsForm = ({ handleChange }) => {
  return (
    <Form.Item name="subscribeTournews" valuePropName="checked" initialValue>
      <div className="legalIssues">
        <Checkbox defaultChecked>
          <SelectTourNews handleChange={handleChange} />
        </Checkbox>
      </div>
    </Form.Item>
  );
};

SelectTourNewsForm.displayName = 'SelectTourNewsForm';
SelectTourNewsForm.propTypes = {
  handleChange: PropTypes.func,
};
